
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 448 448"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":"32","y":"32","width":"384","height":"384","rx":"64","ry":"64","fill":"none","stroke":"currentColor","stroke-width":"32"}}),_c('path',{attrs:{"d":"M174 164l110 60-110 60z","fill":"#fff"}})])
          )
        }
      }
    